import {
  INVENTORIZATION_BLOCK_IDS,
  updateInventorizationBlock,
} from '@/features/inventorization/domain/inventorization';
import { validateInventorizationReviewPrerequisites } from '@/features/inventorization/domain/inventorization-validation';
import { BLOCK_STATUSES, type CaptureSession } from '@/shared/capture/capture-session';

export function acceptInventorizationReview(session: CaptureSession, updatedAt: string): CaptureSession {
  const issues = validateInventorizationReviewPrerequisites(session);

  if (issues.length > 0) {
    return {
      ...session,
      validationErrors: issues,
      updatedAt,
    };
  }

  return {
    ...updateInventorizationBlock(session, INVENTORIZATION_BLOCK_IDS.review, BLOCK_STATUSES.valid, updatedAt),
    validationErrors: [],
  };
}
